import React, { PropsWithChildren, useState } from 'react';
import { useLocation } from 'react-router';

import { getRoute } from 'src/shared/helpers/url';
import {
  CurrentPage,
  Provider as SegmentHistoryProvider,
} from 'src/shared/hooks/useSegmentHistory';

type Props = PropsWithChildren<{}>;

const Provider = ({ children, ...props }: Props) => {
  const { pathname } = useLocation();
  const [page, setPage] = useState<CurrentPage>(
    getRoute(pathname)?.page ?? null,
  );

  return (
    <SegmentHistoryProvider {...props} value={{ page, setPage }}>
      {children}
    </SegmentHistoryProvider>
  );
};

export { Provider };
